import type { RouterLink } from '@/types/Components/Router'
import type { Assignment } from '@/types/Models/Assignment'
import { useAccountStore } from '@/store/account'
import { CUSTOMER_ASSIGNMENTS_DETAILS, STAFF_ASSIGNMENTS_DETAILS } from '@/types/router'

export const useDetailsRoute = (assignment: Assignment): RouterLink => ({
  name: useAccountStore().isStaff ? STAFF_ASSIGNMENTS_DETAILS : CUSTOMER_ASSIGNMENTS_DETAILS,
  params: {
    id: assignment.reference,
  },
})
